import { render, staticRenderFns } from "./CandidatosData.vue?vue&type=template&id=205441fe&"
import script from "./CandidatosData.vue?vue&type=script&lang=js&"
export * from "./CandidatosData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports